import Image from 'next/legacy/image'
import { FC } from 'react'
import Link from 'next/link'

import useDroppeAdCategoryBanner from '../../services/strapi/useDroppeAdCategoryBanner'
import useIsOnMobile from '../../services/useIsOnMobile'
import { ScreenSize } from '../../utils/constants'
import { imageLoader } from '../../utils/images'
import { getStrapiMediaUrl } from '../../utils/strapi'
import { clickDroppeAdEvent } from '../../utils/analytics/droppeAdEvents'
import useViewAdBannerEvent from './hooks/useViewAdBannerEvent'
import { isProduction } from '../../utils/environment'

import styles from '../../styles/CategorySidebarAdBanner.module.less'

const CategorySidebarAdBanner: FC = () => {
  const isOnMobile = useIsOnMobile(ScreenSize.md)
  const adBannerData = useDroppeAdCategoryBanner({ location: 'category_sidebar' })

  const imageObject = isOnMobile
    ? adBannerData?.bannerCategoryPage?.[0]?.mobileBanner
    : adBannerData?.bannerCategoryPage?.[0]?.desktopBanner

  const bannerRef = useViewAdBannerEvent<HTMLDivElement>({ adBannerData, imageObject })

  const imageUrl = getStrapiMediaUrl(imageObject)
  const adTargetUrl = adBannerData?.bannerCategoryPage?.[0]?.link || ''

  const handleOnClick = () => {
    // Don't prevent default to allow the user to open the link in a new tab
    if (adBannerData && imageObject) {
      clickDroppeAdEvent({
        adLocation: 'category_sidebar',
        adCampaign: adBannerData.campaignName || '',
        adName: adBannerData.bannerCategoryPage?.[0]?.adName || '',
        adVariant: imageObject.data.attributes.name || '',
      })
    }
  }

  const isStagingCampaign = adBannerData?.campaignName?.startsWith('staging_') && isProduction

  if (!adBannerData || !imageUrl || isStagingCampaign) {
    return null
  }

  return (
    <div
      ref={bannerRef}
      className={styles['category-sidebar-banner-container']}
    >
      <Link
        href={adTargetUrl}
        target="_blank"
        onClick={handleOnClick}
      >
        <Image
          width={Number(imageObject?.data.attributes.width)}
          height={Number(imageObject?.data.attributes.height)}
          // Height and width represent aspect ratio in "responsive" layout
          layout="responsive"
          src={imageUrl}
          loader={imageLoader}
        />
      </Link>
    </div>
  )
}

export default CategorySidebarAdBanner
